// constants.js
export const BING_API_KEY =
  "AtPZpJTj7Gc4wSv2RUZ_b0zI0B22uXVJGYsNZyyP6wmMUVEnoQwcIuAzLYKbKaQy";
